<template>
  <div class="v-textbox">
    <input
      :class="[
        'v-textbox__input',
        !isValid ? 'v-textbox__input__not-valid' : ''
      ]"
      ref="textbox"
      type="text"
      :name="name"
      :required="required"
      :placeholder="targetPlaceholder"
      @input="onInputEventHandler()"
    >
  </div>
</template>

<script>
export default {
  name: "VTextbox",
  props: {
    type: {
      type: String,
      default: 'text',
      validator: (value) => ['text', 'tel'].includes(value)
    },
    name: String,
    pattern: String,
    placeholder: String,
    required: Boolean,
    value: String
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  data(){
    return {
      isValid: true
    }
  },
  computed: {
    targetPlaceholder() {
      return this.required ? `${this.placeholder}*` : this.placeholder;
    }
  },
  methods: {
    onInputEventHandler(){
      this.$emit('input', this.$refs["textbox"].value);
    },
    checkValidity() {
      this.isValid = this.$refs["textbox"].checkValidity();

      return this.isValid;
    }
  }
};
</script>

<style>
.v-textbox {
  width: 100%;
}

.v-textbox__input {
  font-family: PlumbLightC, sans-serif;
  font-size: 20px;
  border: none;
  border-bottom: 1px solid rgba(134, 134, 134, 0.702);
  height: 40px;
  outline: none;
  width: 100%;
}

.v-textbox__input__not-valid {
  border-bottom: 1px solid rgb(250, 26, 0);
}

@media only screen and (max-width: 600px) {
  .v-textbox__input {
    font-size: 14px;
  }
}
</style>
